<template>
    <div class="user_list">
        <div class="row">
            <div class="col-5 col-sm-3">
                <h5>學員姓名</h5>
                <input type="text" v-model="name" placeholder="請輸入學員姓名" v-validate="'required'" :name="inputName" class="store_input">
                <div class="errors_box">
                    <span>{{ errors.first(inputName) }}</span>
                </div>
            </div>
            <div class="col-7 col-sm-3">
                <h5>學員手機</h5>
                <input type="tel" v-model="phone" placeholder="請輸入學員手機" v-validate="{ required: true, regex: /((?=(09))[0-9]{10})$/ }" :name="inputPhone"
                    class="store_input">
                <div class="errors_box">
                    <span>{{ errors.first(inputPhone) }}</span>
                </div>
            </div>
            <div class="col-sm">
                <h5>電子信箱</h5>
                <input type="email" v-model="email" placeholder="請輸入電子信箱" v-validate="'required'" :name="inputEmail"
                    class="store_input">
                <div class="errors_box">
                    <span>{{ errors.first(inputEmail) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import {
        mapMutations
    } from 'vuex'

    // props,data,computed,methods 可使用this直接拿取
    export default {
        // name: 'userlist',
        inject: ['$validator'], // 將父親的component擁有的拿過來用，不用設任何參數
        props: {
            parentIndex: {
                type: Number,
                required: true,
            },
            index: {
                type: Number,
                required: true,
            },
            user: {
                type: Object,
                required: true,
            },
        },
        computed: {
            inputName() {
                return `name${this.parentIndex}${this.index}`;
            },
            inputPhone() {
                return `phone${this.parentIndex}${this.index}`;
            },
            inputEmail() {
                return `email${this.parentIndex}${this.index}`;
            },
            name: {
                get() {
                    return _.get(this.user, 'name');
                },
                set(val) {
                    this.setCartUser({
                        name: val,
                    });
                },
            },
            phone: {
                get() {
                    return _.get(this.user, 'phone');
                },
                set(val) {
                    this.setCartUser({
                        phone: val,
                    });
                },
            },
            email: {
                get() {
                    return _.get(this.user, 'email');
                },
                set(val) {
                    this.setCartUser({
                        email: val,
                    });
                },
            },
        },
        created() {
            // 將值塞入vee套件(寫上你在data使用的名字作為key)
            let obj = {};

            obj[this.inputName] = {
                required: '請輸入正確資訊'
            };
            obj[this.inputPhone] = {
                required: '請輸入正確資訊',
                regex: '請輸入正確資訊',
            };
            obj[this.inputEmail] = {
                required: '請輸入正確資訊'
            };

            const dict = {
                custom: obj,
                attributes: {},
            };

            dict.attributes[this.inputEmail] = ' ';


            this.$validator.localize('zh_TW', dict);
        },
        methods: {
            ...mapMutations('cart', ['setUser']),
            setCartUser(obj) {
                this.setUser({
                    index: this.index,
                    parentIndex: this.parentIndex,
                    ...obj,
                });
            },
        },
    }
</script>